module.exports = __webpack_public_path__ + "img/divider-dashboard.a2e48d99.svg";